import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputComponent } from '../base/input.component';
import { AltNeu } from '../../core/types';
import { TextListInputComponent } from './list-input.component';

@Component({
    standalone: true,
    imports: [CommonModule, TextListInputComponent],
    selector: 'wd-an-list-input',
    templateUrl: 'alt-neu-list-input.component.html',
    styleUrls: ['../styles/input.component.css', '../styles/view.component.css'],
})
export class AltNeuTextListInputComponent extends InputComponent<AltNeu<string>> {
	constructor() {
		super();
	}
}
